import React from "react";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";
import "../css/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left: Logo */}
        <div className="footer-left">
          <div className="footer-logo">
            <img src="/hh logo.jpeg" alt="Logo" />
            <h4>HandH Fashion</h4>
          </div>
        </div>

        {/* Center: Links */}
        <div className="footer-center">
          <ul className="footer-links">
            <li><a href="/Terms">Terms and Conditions</a></li>
            <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
              {/* <li><a href="/privacy.html">Privacy Policy</a></li> */}
            <li><a href="/user-data-deletion">User Data Deletion</a></li>
          </ul>
        </div>

        {/* Right: Social Icons */}
        <div className="footer-right">
          <a href="https://wa.me/your-number" target="_blank" rel="noopener noreferrer" className="social-icon"><FaWhatsapp /></a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebookF /></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
          <a href="mailto:yourmail@gmail.com" className="social-icon"><FaEnvelope /></a>
        </div>
      </div>

      {/* Bottom: Copyright */}
      <div className="footer-bottom">
        <p>&copy; 2025 HandH Fashion. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
